import styled from 'styled-components';
import { NonDraggableImage } from '../../common/styledComponents';

interface WheelFaceProps {
  $background: string;
  $outerBorderColor: string;
  $outerBorderWidth: number;
}

interface WheelSeparatorProps {
  $color: string;
  $width: number;
  $height: number;
  $bottom: number;
  $rotation: number;
}

interface WheelInnerCircleProps {
  $diameter: number;
  $borderColor: string;
  $borderWidth: number;
}

interface WheelImageShellProps {
  $left: number;
  $top: number;
  $width: number;
  $height: number;
  $rotation: number;
}

interface WheelImageProps {
  $offsetX: number;
  $offsetY: number;
}

interface WheelTextProps {
  $left: number;
  $top: number;
  $rotation: number;
  $fontFamily: string;
  $fontWeight: number | string;
  $fontSize: number;
  $fontStyle: string;
  $textColor?: string;
}

export const WheelCanvasStyle = styled.div`
  position: relative;
  width: 98%;
  height: 98%;
  border-radius: 50%;
  overflow: hidden;
  pointer-events: none;
`;

export const WheelFace = styled.div<WheelFaceProps>`
  position: absolute;
  inset: 0;
  z-index: 1;
  border-radius: 50%;
  box-sizing: border-box;
  background: ${({ $background }) => $background};
  border: ${({ $outerBorderWidth, $outerBorderColor }) => (
    $outerBorderWidth > 0 ? `${$outerBorderWidth}px solid ${$outerBorderColor}` : 'none'
  )};
`;

export const WheelSeparator = styled.div<WheelSeparatorProps>`
  position: absolute;
  left: 50%;
  z-index: 2;
  width: ${({ $width }) => `${$width}px`};
  height: ${({ $height }) => `${$height}%`};
  bottom: ${({ $bottom }) => `${$bottom}%`};
  background: ${({ $color }) => $color};
  transform: translateX(-50%) rotate(${({ $rotation }) => `${$rotation}deg`});
  transform-origin: center bottom;
`;

export const WheelInnerCircle = styled.div<WheelInnerCircleProps>`
  position: absolute;
  top: 50%;
  left: 50%;
  z-index: 3;
  width: ${({ $diameter }) => `${$diameter}%`};
  height: ${({ $diameter }) => `${$diameter}%`};
  border-radius: 50%;
  box-sizing: border-box;
  background: white;
  border: ${({ $borderWidth, $borderColor }) => (
    $borderWidth > 0 ? `${$borderWidth}px solid ${$borderColor}` : 'none'
  )};
  transform: translate(-50%, -50%);
`;

export const WheelImageShell = styled.div<WheelImageShellProps>`
  position: absolute;
  left: ${({ $left }) => `${$left}%`};
  top: ${({ $top }) => `${$top}%`};
  z-index: 4;
  width: ${({ $width }) => `${$width}%`};
  height: ${({ $height }) => `${$height}%`};
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: visible;
  transform: translate(-50%, -50%) rotate(${({ $rotation }) => `${$rotation}deg`});
  transform-origin: center center;
`;

export const WheelImage = styled(NonDraggableImage) <WheelImageProps>`
  display: block;
  width: auto;
  height: 100%;
  max-width: none;
  max-height: none;
  flex-shrink: 0;
  transform: translate(${({ $offsetX }) => `${$offsetX}%`}, ${({ $offsetY }) => `${$offsetY}%`});
`;

export const WheelText = styled.div<WheelTextProps>`
  position: absolute;
  left: ${({ $left }) => `${$left}%`};
  top: ${({ $top }) => `${$top}%`};
  z-index: 4;
  color: ${({ $textColor }) => $textColor || 'black'};
  font-family: ${({ $fontFamily }) => $fontFamily}, Helvetica, Arial, sans-serif;
  font-size: ${({ $fontSize }) => `${$fontSize}px`};
  font-style: ${({ $fontStyle }) => $fontStyle};
  font-weight: ${({ $fontWeight }) => $fontWeight};
  line-height: 1;
  white-space: nowrap;
  transform: translate(-50%, -50%) rotate(${({ $rotation }) => `${$rotation}deg`});
  transform-origin: center center;
`;
